/**
 * LoginSplashGuide 组件类型定义
 * 移动端登录启动引导页
 */

export const preloadImages = (imageUrls: string[]) => {
  imageUrls.forEach((url) => {
    const img = new window.Image();
    img.src = url;
  });
};
